<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="vipFlag" size="50%" :before-close="AddNone">
      <div class="demo-drawer__content">
      <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">

        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="父级" prop="pid">

            <el-select v-model="selectValue" ref="tree" class="w100">
              <el-option style="height: 100%; padding: 0">
                <el-tree
                    :data="options"
                    ref="tree"
                    :node-key="treeId"
                    highlight-current
                    @node-click="handleNodeClick"

                    :props="treeProps">
                </el-tree>

              </el-option>

            </el-select>


          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="规则" prop="url">
            <el-input v-model="addFrom.url" placeholder="规则任意,不可重复,仅做层级显示,无需匹配控制器和方法"
                      clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="标题" prop="title">
            <el-input v-model="addFrom.title" placeholder="请输入标题" clearable></el-input>
          </el-form-item>
        </el-col>
        <!--              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">-->
        <!--                <el-form-item label="图标">-->
        <!--                  <el-popover-->
        <!--                      placement="bottom-start"-->
        <!--                      width="460"-->
        <!--                      trigger="click"-->
        <!--                      @show="$refs['iconSelect'].reset()"-->
        <!--                  >-->
        <!--                    <IconSelect ref="iconSelect" @selected="selected" :active-icon="addFrom.icon" />-->
        <!--                    <el-input slot="reference" v-model="addFrom.icon" placeholder="点击选择图标" readonly>-->
        <!--                      <svg-icon-->
        <!--                          v-if="addFrom.icon"-->
        <!--                          slot="prefix"-->
        <!--                          :icon-class="addFrom.icon"-->
        <!--                          style="width: 25px;"-->
        <!--                      />-->
        <!--                      <i v-else slot="prefix" class="el-icon-search el-input__icon" />-->
        <!--                    </el-input>-->
        <!--                  </el-popover>-->
        <!--                </el-form-item>-->

        <!--              </el-col>-->
        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="权重">
            <el-input v-model="addFrom.weigh" placeholder="请输入权重" @input="validatePositiveNumber" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="15" class="mb20">
          <el-form-item label="状态">
            <el-radio-group v-model="addFrom.status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="15" class="mb20">
          <el-form-item label="是否是菜单">
            <el-radio-group v-model="addFrom.ismenu">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import IconSelect from "../../../../components/IconSelect";
import {optimizationAPI} from '@/api/authRule/rule';
import { processErrors } from "@/utils/errorHandler";

export default {
  props: ['vipFlag', "editID"],
  components: {IconSelect},
  data() {
    return {
      title: "新增",
      options: [{
        pid: '1',
        title: '无父级'
      }],
      // 树id
      treeId: '',
      queryParams: {
        pageNo: 1,
        pageSize: 9999,

      }, treeProps: {
        label: 'title',
        children: 'children',
        id: 'id',
        pid: 'pid'
      },
      menuList: [],
      menuListCache: [],
      addFrom: {
        id: '',
        pid: '',
        title: '',
        url: '',
        weigh: '',
        status: 1,
        icon: '',
        ismenu: 1
      }
      , rules: {


        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],


        url: [
          {required: true, message: '请输入规则', trigger: 'blur'},
        ],

      },
      selectValue: "",
      nameRole: "优化师",
      appidList: [],
      selectNode: {},
      EditFlag: false,
      isInputDisabled: true,
      radioFlag: true,
      TiktokList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "1"
      },

      flagTab: false
    };
  },
  created() {


  },

  methods: {
    // 只允许输入正数
    validatePositiveNumber(value) {
      // 用正则表达式检查值，只允许正整数或正浮动小数
      const regex = /^[+]?\d*\.?\d*$/;
      if (!regex.test(value)) {
        // 如果输入不符合正数格式，恢复为原值
        this.addFrom.weigh = value.slice(0, -1);
      }
    },

    // 选择图标
    selected(name) {
      this.form.icon = name;
    },

    getList() {
      let api = optimizationAPI()

      api.getRuleList(this.queryParams).then(res => {
        if (res.code == 0) {

          this.menuList = res.data.data
          this.menuListCache = res.data.data
          const data = this.buildTree(res.data.data)

          data.forEach(item => {
            this.options.push({
              id: item.id,
              pid: item.pid,
              title: item.title,
              children: item.children
            })

          })
        }else{
          processErrors(res);
        }
      })

    },
    buildTree(data) {
      let tree = [];
      let lookup = {};

      data.forEach(item => {
        lookup[item.id] = {...item, children: []};
      });

      data.forEach(item => {
        if (item.pid === 1) {
          tree.push(lookup[item.id]);
        } else {
          if (lookup[item.pid]) {
            lookup[item.pid].children.push(lookup[item.id]);

          } else {
            tree.push(lookup[item.id]); // root elements with missing parent
          }
        }
      });

      return tree;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done()
          })
          .catch(_ => {
          });
      this.$refs['ruleForm'].resetFields();
    },
    reset() {
      this.addFrom = {}
    },
    // 点击节点的响应
    handleNodeClick(node) {
      this.selectValue = node.title;
      this.addFrom.pid = node.id
      this.selectNode = node
      // 确保 selectTree 组件存在
      if (this.$refs.tree) {
        this.$refs.tree.blur();
      }
    },
    AddNone() {
      this.addFrom = {}
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NonevipFlag');
    },
    findTitleById(nodes, pid) {
      for (const node of nodes) {
        if (node.id === pid) {

          return node.title;
        }
        if (node.children) {
          const title = this.findTitleById(node.children, id);
          if (title) {
            return title;
          }
        }
      }
      return null;
    },
    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let api = optimizationAPI()
          this.addFrom.pid = 1;
          if (this.selectNode.id !== undefined) {
            this.addFrom.pid = this.selectNode.id
          }
          this.$delete(this.addFrom, 'parent_title');
          api.addAndEditRule(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddVipok');
            }else{
              processErrors(res);
            }

          })
        } else {
          return false;
        }
      });

    }
  },

  mounted() {

    this.getList()
    let api = optimizationAPI()

    if (this.editID) {
      this.title = "编辑"

      this.EditFlag = true
      this.isInputDisabled = true
      this.radioFlag = true
      this.flagTab = true
      api.getRuleInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.reset();

          if (res.data.pid === 1 || res.data.pid === 0) {
            this.selectValue = "无父级"
          } else {
            this.selectValue = res.data.parent_title
          }

          this.selectNode.id = res.data.pid

          this.addFrom = res.data
        }else{
          processErrors(res);
        }
      })
    } else {

    }
  },
  getRuleInfo() {

  }
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>
